import { FC, SVGProps } from 'react';

const TimerSimpleIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({
  color = '#DF9A30',
  size = 18,
  ...props
}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" {...props} fill="none">
      <path
        d="M15.4885 3.9351C14.8251 3.19794 14.421 2.85678 13.624 2.34839"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.51123 3.9351C3.17464 3.19794 3.57874 2.85678 4.37572 2.34839"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.08136 15.7498C12.5344 15.7498 15.3331 12.9504 15.3331 9.49811C15.3331 6.0451 12.5344 3.24634 9.08136 3.24634C5.62834 3.24634 2.82959 6.0451 2.82959 9.49811C2.82959 12.9504 5.62834 15.7498 9.08136 15.7498Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.3816 10.8738L9.0813 9.49915V6.52979"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default TimerSimpleIcon;
